import { render } from "./injuryGrade.vue?vue&type=template&id=c869b402&scoped=true"
import script from "./injuryGrade.vue?vue&type=script&lang=js"
export * from "./injuryGrade.vue?vue&type=script&lang=js"

import "./injuryGrade.vue?vue&type=style&index=0&id=c869b402&lang=scss&scoped=true"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c869b402"]])

export default __exports__